<template>
  <BaseSection :config="sectionConfig">
    <p v-if="!appearanceStore.account.customer.isEdited" class="section__info">
      {{ fullName }}
    </p>
    <MyForm
      v-else
      :state="form"
      :schema="schema"
      class="section__form"
      @submit="onSubmit"
      @keydown.esc="onCancel"
    >
      <div class="section__fields">
        <MyInput
          v-model.trim="form.lastName"
          name="lastName"
          caption="@Last name"
          autocomplete="family-name"
        />
        <MyInput
          v-model.trim="form.firstName"
          name="firstName"
          caption="@Name"
          autocomplete="given-name"
        />
      </div>
      <Actions :on-cancel="onCancel" :is-disabled="isDisabled" />
    </MyForm>
  </BaseSection>
</template>

<script setup>
import { useUserStore } from "~/store/userStore";
import { useAppearanceStore } from "~/store/appearanceStore.js";
import BaseSection from "~/modules/account/ui/pages/Profile/BaseSection.vue";
import { z } from "zod";
import MyForm from "~/nuxt_modules/common/ui/components/form/MyForm.vue";
import MyInput from "~/nuxt_modules/common/ui/components/form/MyInput.vue";
import {
  successfulModal,
  useModalStore,
} from "~/modules/shared/modals/store/modalStore.js";
import Actions from "~/modules/account/ui/pages/Profile/Actions.vue";

const appearanceStore = useAppearanceStore();
const userStore = useUserStore();
const { currentUser: user, userFullName: fullName } = storeToRefs(userStore);
const modalStore = useModalStore();

const sectionConfig = {
  name: "customer",
  title: "@Personal data",
  image: "account-customer",
};

const successfulData = {
  title: _T("@Successful change profile title"),
  description: _T("@Successful change profile description"),
  isWithTimeout: true,
};

const initialForm = computed(() => ({
  firstName: user.value.name.firstName,
  lastName: user.value.name.lastName,
}));

const form = reactive({
  firstName: user.value.name.firstName,
  lastName: user.value.name.lastName,
});

const schema = z.object({
  firstName: z
    .string(_T("@Entry field required"))
    .max(255, `${_T("@Maximum field length")} 255`)
    .regex(/^\S*$/, _T("@Must not contain spaces")),
  lastName: z
    .string(_T("@Entry field required"))
    .max(255, `${_T("@Maximum field length")} 255`)
    .regex(/^\S*$/, _T("@Must not contain spaces")),
});

const isDisabled = computed(
  () => JSON.stringify(initialForm.value) === JSON.stringify(form),
);

const onSubmit = async (data) => {
  await userStore
    .updateAccount({
      name: { ...data },
    })
    .then(async () => {
      await userStore.fetch();
      onCancel();
      modalStore.toggleModal(successfulModal, successfulData);
    });
};

function onCancel() {
  appearanceStore.account.customer.isEdited = false;
  Object.assign(form, initialForm.value);
}
</script>
